import {OrderService, MovieMetaService, ErrorHandler} from 'hasta-la-vista-middleware-api/service'

// import {Ticket} from 'hasta-la-vista-middleware-api/model'
export default {

    props: {
        order: Object,
        movie: Object,
        cinema: Object,
    },

    data() {
        return {
            ticketMobile: false,
            toggleDialog: false,
            cancelOrderLoad: false,
            maxTotal: 5000,
            subsClubComboPrice: 51.84,
            subsClubComboPriceInCents: 5184,
            currency: "R"
        }
    },

    computed: {
        ticketsGrouped() {

            if (!this.order || !this.order.Tickets) {
                return []
            }

            var tickets = this.order.Tickets.reduce((collection, ticket) => {
                let key = ticket.Description;
                collection[key] = collection[key] || {
                    Description: ticket.Description,
                    PriceInCents: ticket.PriceCents,
                    Quantity: 0
                };
                // console.log((collection[key].Description.includes('SK MORvies') && collection[key].Description.includes('Combo')) || (collection[key].Description.includes('SK Fan') && collection[key].Description.includes('Combo')))
                if((collection[key].Description.includes('SK MORvies') && collection[key].Description.includes('Combo')) || (collection[key].Description.includes('SK Fan') && collection[key].Description.includes('Combo'))) {
                    if(collection[key].PriceInCents == 0) {
                        collection[key].PriceInCents = this.subsClubComboPriceInCents
                    }
                }
                collection[key].Quantity++;
                return collection;
            }, {});

            return tickets;
        },
        total() {
            if (!this.order || !this.order.Tickets) {
                return this.currency+'0.00'
            }

            // var totalTicketPrice = this.order.Tickets.reduce((v, t)=>v += t.price, 0)
            var ConcessionTotal = this.order && this.order.Concessions ? this.order.Concessions.reduce((c, t) => c += (t.PriceInCents * t.Quantity), 0) : 0
            
            var totalTicketPrice = this.order.Sessions ? this.order.Sessions.reduce((collection, session) => {
                var totalTicketPrice = session.Tickets ? session.Tickets.reduce((v, t) => v += t.PriceCents / 100, 0) : 0;
                return collection += totalTicketPrice;
            }, 0) : 0;

            totalTicketPrice += ConcessionTotal / 100;

            var priceFormatted = (totalTicketPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return this.currency+`${priceFormatted}`
       },
        isConcessionStep(){
            return ~this.$route.path.indexOf('booking/2')
        },

        orderTotal() {
            let hasSubsCombo = false
            let comboCount = 0
            let orderTotal = 0;

            if(this.order != undefined && this.order != null) {
                //console.log(this.order.Concessions)

                if(this.order.Concessions != undefined && this.order.Concessions != null) {
                    for(let i = 0;i <= this.order.Concessions.length; i++) {
                        if(this.order.Concessions[i] != undefined && this.order.Concessions[i] != null) {

                            orderTotal += (this.order.Concessions[i].PriceInCents ? this.order.Concessions[i].PriceInCents * this.order.Concessions[i].Quantity :this.order.Concessions[i].PriceInCents * this.order.Concessions[i].Quantity)
                        }
                    }
                }

                if(this.order.Tickets != undefined && this.order.Tickets != null) {
                    for(let i = 0;i <= this.order.Tickets.length; i++) {
                        let ticket = this.order.Tickets[i];
                        //console.log("orderTotal ticket", ticket)
                        if(this.order.Tickets[i] != undefined && this.order.Tickets[i] != null) {
                            

                            orderTotal += (this.order.Tickets[i].PriceCents ? this.order.Tickets[i].PriceCents :this.order.Tickets[i].PriceCents)

                            // if((this.order.Tickets[i].Description.includes('MORvies') && this.order.Tickets[i].Description.includes('Combo')) || (this.order.Tickets[i].Description.includes('Fan Club') && this.order.Tickets[i].Description.includes('Combo'))) {
                            //     if(this.order.Tickets[i].PriceCents == 0) {
                            //         comboCount++
                            //         hasSubsCombo = true
                            //     }
                            // }
                        }
                    }
                }
            } 

            //console.log("orderTotal",orderTotal)

            let totalTicketPrice = orderTotal/100
            let priceFormatted = (totalTicketPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return this.currency+`${priceFormatted}`

            // if(hasSubsCombo) {

            //     if(comboCount > 0) {
            //         let comboTotal = comboCount * this.subsClubComboPriceInCents
            //         let totalTicketPriceInCents = this.order.totalInCents
            //         let totalTicketPrice = (totalTicketPriceInCents + comboTotal) / 100

            //         let priceFormatted = (totalTicketPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            //         return `R${priceFormatted}`
            //     }

            // } else if(!hasSubsCombo) {
            //     let totalTicketPrice = this.order.totalInCents /100
            //     let priceFormatted = (totalTicketPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            //     return `R${priceFormatted}`
            // }
        },
    },

    methods: {
        setSessionsToNull() {
            this.order.Sessions = null;
        },
        openDialog() {
            if (this.$breakpoints.xs) this.ticketMobile = true
            else this.ticketMobile = false
        },

        cancelOrder() {
            ErrorHandler.ignoreNextError();
            this.cancelOrderLoad = true;
            let session = OrderService.pendingSession();
            let result = Promise.resolve(OrderService.cancelOrder()).then((result) => {
                OrderService.clearPendingSessions();
                OrderService.tearDown();
                this.$toaster.show('Your booking was successfully cancelled.', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                if (session.MovieId)
                    this.$router.push('/details/' + session.MovieId);
                else{
                    this.$router.push('/');
                }
                this.cancelOrderLoad = false
            }, (e) => {
                let session = OrderService.pendingSession();
                OrderService.tearDown();
                this.$router.push('/details/' + session.MovieId);
            });
        },
        confirmCancelOrder() {
            this.toggleDialog = true
        }
    },

    created() {

        Promise.resolve(MovieMetaService.getMovieMeta()).then((meta) => {
            if(meta.extended_regions_data != undefined) {
                for(let i = 0; i < meta.extended_regions_data.length; i++) {
                    if(meta.extended_regions_data[i] != undefined) {
                        if(meta.extended_regions_data[i].cinema_id == this.order.CinemaId) {
                            this.currency = meta.extended_regions_data[i].currency_symbol
                        }
                    }
                }
            }
        })

        Promise.resolve(OrderService.getPaymentConfig()).then((result) => {

            if (result.data) {
                this.maxTotal = parseInt(result.data[0].max_amount)
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/components/booking/ticket/ticket.js